import DEFAULT_RADIO_CLASS_NAME, {
  RADIO_BORDER_HOVER_COLOR_VAR,
  RADIO_CHECKED_BG_COLOR_VAR,
  RADIO_CHECKED_MAIN_COLOR_VAR,
} from '../../constants/radio';

/**
 * Why CSS variables instead of direct styles?
 *
 * FingoRadio/FingoCheckedRadio are styled('span') components passed as `icon` and `checkedIcon`
 * props to MUI's <Radio>. These styled components have high specificity, making them hard to
 * override from the theme.
 *
 * SOLUTION: CSS Custom Properties allow inheritance through the DOM tree:
 * - Parent <Radio> defines variables with theme values
 * - Child styled spans read them via var(--variable-name, fallback)
 * - This bypasses specificity issues and enables theme-level control
 *
 * Flow: <Radio style="--color: blue"> → <span style="color: var(--color)"> ✅
 */
const defaultRadioStyles = ({ theme }) => ({
  [RADIO_BORDER_HOVER_COLOR_VAR]: theme.palette.primary.main,
  [RADIO_CHECKED_BG_COLOR_VAR]: theme.palette.primary.A100,
  [RADIO_CHECKED_MAIN_COLOR_VAR]: theme.palette.primary.main,
});

const MuiRadio = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${DEFAULT_RADIO_CLASS_NAME}`]: defaultRadioStyles({ theme }),
    }),
  },
};

export default MuiRadio;
